import { render } from "./Request.view.vue?vue&type=template&id=6f8f15b5"
import script from "./Request.view.vue?vue&type=script&lang=js"
export * from "./Request.view.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__